export default __webpack_public_path__ + "static/media/icon_screen.c83b651a.jpg";